import { render, staticRenderFns } from "./KeyMappings.vue?vue&type=template&id=48f94737&scoped=true&"
import script from "./KeyMappings.vue?vue&type=script&lang=js&"
export * from "./KeyMappings.vue?vue&type=script&lang=js&"
import style0 from "./KeyMappings.vue?vue&type=style&index=0&id=48f94737&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f94737",
  null
  
)

export default component.exports